import { put, call, takeLatest } from 'redux-saga/effects';
import { dataApi } from '../../apis';
import handleError from '../handleError';
import {
  SET_MARKET,
  SET_USER_IS_GLOBAL,
  SET_USER_IS_SERVICE_OFFICE,
  GET_MARKET_CONFIGS,
  GET_MARKET_NAME,
  FETCH_CONFIG_SEPRATELY
} from './constants';
import { AUTHENTICATE_DONE } from '../loginSystem/constants';
import { persistObjectToLocalStorage } from '../utils/localStorage';
import {
  setLanguage,
  getConfigsFailed,
  getConfigsDone,
  getGlobalConfigsDone,
  getGlobalConfigsFailed,
  getMarketConfigsDone,
  getMarketConfigsFailed,
  getMarketNameDone,
  getMarketNameFailed
} from './actions';

export function* fetchConfigs() {
  try {
    const response = yield call(dataApi.fetchConfigs);
    yield put(getConfigsDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchConfigsFail',
      put(getConfigsFailed(error))
    );
  }
}

export function* fetchGlobalConfigs() {
  try {
    const response = yield call(dataApi.fetchGlobalConfigs);
    yield put(getGlobalConfigsDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchGlobalConfigsFail',
      put(getGlobalConfigsFailed(error))
    );
  }
}

export function* setMarket({ payload: { market } }) {
  yield call(persistObjectToLocalStorage, 'market', market);
  yield call(dataApi.setMarket, market.market);
  yield put(setLanguage(market.ifoodPPSILanguageCodes[0]));
}

export function* setUserIsGlobal() {
  yield call(dataApi.setIsGlobalUser);
}

export function* setUserIsServiceOffice() {
  yield call(dataApi.setIsServiceOfficeUser);
}

// Adding to check market config API

export function* fetchMarketConfigs(action) {
  try {
    const marketCode = action.payload;
    const response = yield call(dataApi.fetchMarketConfigs, marketCode);
    yield put(getMarketConfigsDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchGlobalConfigsFail',
      put(getMarketConfigsFailed(error))
    );
  }
}

export function* getMarketName() {
  try {
    const response = yield call(dataApi.fetchMarketName);
    yield put(getMarketNameDone(response.data));
  } catch (error) {
    yield call(
      handleError,
      error,
      'notify.fetchMarketNameFail',
      put(getMarketNameFailed(error))
    );
  }
}

export default [
  takeLatest(AUTHENTICATE_DONE, fetchConfigs),
  takeLatest(SET_MARKET, setMarket),
  takeLatest(SET_MARKET, fetchConfigs),
  takeLatest(FETCH_CONFIG_SEPRATELY, fetchConfigs),
  takeLatest(GET_MARKET_CONFIGS, fetchMarketConfigs),
  takeLatest(SET_USER_IS_GLOBAL, setUserIsGlobal),
  takeLatest(SET_USER_IS_SERVICE_OFFICE, setUserIsServiceOffice),
  takeLatest(SET_USER_IS_SERVICE_OFFICE, fetchGlobalConfigs),
  takeLatest(GET_MARKET_NAME, getMarketName)
];
